import { Controller } from "@hotwired/stimulus"

// The "More" fold for the main sections (Projects, Flows and You by default;
// Edit Nav moves sections in and out). The server marks the folded links
// is-core-nav-extra and leaves the active one unmarked, so this only opens and
// closes the fold. Its own class, not nav-more's, so opening one fold does not
// open the Apps one. Left open, it stays open from page to page: the cookie is
// read by the nav partial, which draws the next page's fold already open.
export default class extends Controller {
    static targets = ["toggle", "label"]

    toggle() {
        const open = !this.element.classList.contains("is-core-more-open")
        this.element.classList.toggle("is-core-more-open", open)
        if (this.hasToggleTarget) this.toggleTarget.setAttribute("aria-expanded", String(open))
        if (this.hasLabelTarget) this.labelTarget.textContent = open ? "Less" : "More"
        rememberFold("nav_core_more", open)
    }
}

// Shared with nav_more_controller (the Apps fold).
export function rememberFold(name, open) {
    document.cookie = open ? `${name}=1; path=/; max-age=31536000; SameSite=Lax` : `${name}=; path=/; max-age=0; SameSite=Lax`
}
